import React from 'react';
import { Button } from '@material-ui/core';
import { ArrowDropDown, ArrowDropUp, ArrowRight, FiberManualRecord } from '@material-ui/icons';
import MuiMenu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { METRICS_OPTIONS } from '../../../constants/formMeta/growthTrends';
import { has } from 'lodash';
import { flattenNestedArray } from '../../../utility/common';
export default class MultiLevelDropdown extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorElement: null,
      open: false,
      parentsVal: [],
    };
    // this.getParentMenus('CLSScore', METRICS_OPTIONS);
  }

  getParentMenus = async (str, options) => {
    for await (var item of options) {
      if (item.value == str) {
        this.state.parentsVal.push(item.value);
        return true;
      }
      if (item.subMenuItems) {
        if (await this.getParentMenus(str, item.subMenuItems)) {
          this.state.parentsVal.push(item.value);
          return true;
        }
      }
    }
    return false;
  };

  handleButtonClick = (event) => {
    this.setState({
      anchorElement: event.currentTarget,
      open: !this.open,
    });
  };

  handleMenuClose = () => {
    this.setState({
      anchorElement: null,
      open: false,
    });
  };

  render() {
    const { anchorElement, open } = this.state;
    const { defaultValue } = this.props;
    const resultantOptions = flattenNestedArray(this.props.options, 'subMenuItems');
    const selectedOption = this.props.value
      ? this.props?.text?.toLowerCase() === 'conversion (google ads)'
        ? 'Conversion (Google Ads)'
        : this.props?.text?.toLowerCase() === 'conversion rate (google ads)'
        ? 'Conversion Rate (Google Ads)'
        : resultantOptions.find((i) => i.value == this.props.value)
      : defaultValue
      ? resultantOptions.find((i) => i.value == defaultValue)
      : undefined;
    return (
      <React.Fragment>
        <div
          id="content_recommendation__div__multi_level_dropdown_0"
          className={this.props.className || 'popover-button simple-dropdown'}
        >
          <Button
            id="content_recommendation__button__multi_level_dropdown_1"
            disabled={this.props.disabled}
            onClick={this.handleButtonClick}
            className="btnDropdown pd-0 large"
          >
            <label>{selectedOption ? selectedOption.text || selectedOption : ''}</label>
            {!this.state.anchorElement ? <ArrowDropDown /> : <ArrowDropUp />}
          </Button>
        </div>
        <EnhancedMenu
          isParent
          parentId={this.props.id}
          open={Boolean(anchorElement)}
          menuItems={this.props.options}
          onChange={(e) => {
            this.props.onChange(e);
            this.handleMenuClose();
          }}
          anchorElement={anchorElement}
          onClose={this.handleMenuClose}
          showColorBullets={this.props.showColorBullets}
        />
      </React.Fragment>
    );
  }
}

class SubMenu extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      menuOpen: false,
      anchorElement: null,
    };
  }

  handleItemClick = (event) => {
    if (!this.anchorElement) {
      this.setState({
        anchorElement: event.currentTarget,
      });
    }

    this.setState({
      menuOpen: !this.menuOpen,
    });
  };

  handleSubMenuClose = () => {
    this.setState({
      menuOpen: false,
    });
  };

  render() {
    const { text, menuItems, showNewBadge = false } = this.props;
    const { anchorElement, menuOpen } = this.state;
    return (
      <React.Fragment>
        <MenuItem onClick={this.handleItemClick} className="dropdown-menu">
          {text}
          {showNewBadge ? (
            <>
              {' '}
              &nbsp; <span className="new-badge">NEW</span>
            </>
          ) : (
            ''
          )}
          <ArrowRight />
        </MenuItem>
        <EnhancedMenu
          anchorOrigin={{
            vertical: 'top',
            horizontal: 'right',
          }}
          transformOrigin={{
            vertical: 'top',
            horizontal: 'left',
          }}
          open={menuOpen}
          menuItems={menuItems}
          onChange={this.props.onChange}
          anchorElement={anchorElement}
          onClose={this.handleSubMenuClose}
          showColorBullets={this.props.showColorBullets}
        />
      </React.Fragment>
    );
  }
}

const METRIC_DOT_CLASSNAME_MAPPING = {
  clicks: 'clicks',
  impressions: 'impressions',
  'market^_share': 'market_share',
};

class EnhancedMenu extends React.Component {
  renderMenuItems = () => {
    const { menuItems } = this.props;
    return menuItems.map((menuItem) => {
      if (menuItem.hasOwnProperty('subMenuItems')) {
        return (
          <SubMenu
            key={menuItem.value}
            text={menuItem.text}
            menuItems={menuItem.subMenuItems}
            onChange={this.props.onChange}
            showColorBullets={this.props.showColorBullets}
            showNewBadge={menuItem?.showNewBadge}
          />
        );
      }

      return (
        <MenuItem
          className={`dropdown-menu ${
            this.props.showColorBullets ? 'dflex align-items-Center j-content-space-bet color-bullet' : ''
          }`}
          key={menuItem.key}
          id={`trends-dropdown-item-${menuItem.text.replace(/\s+/g, '-')?.toLowerCase()}-${this.props.parentId}`}
          onClick={() => this.props.onChange({ ...menuItem })}
        >
          <div>
            {menuItem.text}
            {menuItem.subtext ? <div style={{ color: 'grey', fontSize: '10px' }}>{menuItem.subtext}</div> : ''}
          </div>
          {this.props.showColorBullets && ['clicks', 'impressions', 'market^_share'].includes(menuItem.value) ? (
            <FiberManualRecord className={METRIC_DOT_CLASSNAME_MAPPING[menuItem.value]} />
          ) : null}
        </MenuItem>
      );
    });
  };

  render() {
    const { anchorElement, open, onClose, ...others } = this.props;
    return (
      <MuiMenu
        PaperProps={{
          className: 'dropdown-popover-wrapper',
        }}
        getContentAnchorEl={null}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        marginThreshold={0}
        {...others}
        anchorEl={anchorElement}
        open={open}
        onClose={onClose}
      >
        <div
          onMouseLeave={() => {
            if (!this.props.isParent) {
              onClose();
            }
          }}
        >
          {this.renderMenuItems()}
        </div>
      </MuiMenu>
    );
  }
}
